import React, { Component } from 'react'
import { Modal, Form, Select, Radio, Popconfirm, Spin, Button } from 'antd'
import { app } from "../../app"
import Card2 from "../../components/Card2"
import api from "../../api"

const FormItem = Form.Item
const Option = Select.Option

class WhiteList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            playerList: [],
            areaList: [],
            level: '3',
            add_visible: false,
            player_search_type: 'searchform_name'
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleData()
        this.handleAreaData(this.state.level)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 列表数据
     */
    handleData = async () => {
        const params = {
            type: this.state.level,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        const { flag, data, msg } = await app.post(api.ReportsAuthorizeList, params)
        let state = {}
        if (flag === 1) {
            state.dataList = data
        } else {
            state.dataList = []
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 等级按钮组
     * @param level
     */
    handleBtnChange = async (e) => {
        const { value } = e.target
        if (this.state.level !== value) {
            await this.setState({ level: value })
            await this.handleData(value)
            await this.handleAreaData(value)
        }
    }

    /**
     * 打开
     */
    handleOpenAddModal = () => {
        this.setData({ add_visible: true })
    }

    /**
     * 关闭
     */
    handleCloseAddModal = () => {
        this.setData({ add_visible: false })
    }

    /**
     * 搜索队员
     */
    handleSearchPlayer = async (value) => {
        if (value) {
            await this.setData({ player_loading: true })
            const params = {
                search_type: this.state.player_search_type,
                search_val: value,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            }
            const { flag, data, msg } = await app.post(api.ReportsSearchPlayer, params)
            let state = { player_loading: false }
            if (flag === 1) {
                state.playerList = data
            } else {
                state.playerList = []
                app.alert(msg, "error")
            }
            await this.setData(state)
        } else {
            await this.setData({ playerList: [] })
        }
    }

    /**
     * 区域数据
     */
    handleAreaData = async (type) => {
        if ('23'.indexOf(type) !== -1) {
            await this.setData({ area_loading: true })
            const params = {
                type,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            }
            const { flag, data, msg } = await app.post(api.ReportsAuthorizeArea, params)
            let state = { area_loading: false }
            if (flag === 1) {
                state.areaList = data
            } else {
                state.areaList = []
                app.alert(msg, "error")
            }
            await this.setData(state)
        } else {
            await this.setData({ areaList: [] })
        }
    }

    /**
     * 添加
     * @param e
     */
    handleAdd = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                await this.setData({ add_loading: true })
                let { level } = this.state
                if (level !== '1') values.object = values.object.join(',')
                values.object_type = level
                values.indexno = app.getData("indexno")
                values.account = app.getData("account")
                const { flag, msg } = await app.post(api.ReportsAuthorizeAdd, values)
                let state = { add_loading: false }
                if (flag === 1) {
                    app.alert("添加成功", "success")
                    state.add_visible = false
                    await this.setData(state)
                    await this.handleData()
                } else {
                    await this.setData(state)
                    app.alert(msg, "error")
                }
            }
        })
    }

    /**
     * 删除
     * @param id
     * @returns {Promise<void>}
     */
    handleDetele = async (id) => {
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        const { flag, msg } = await app.post(api.ReportsAuthorizeDel, params)
        if (flag === 1) {
            app.alert("删除成功", "success")
            await this.handleData()
        } else {
            app.alert(msg, "error")
        }
    }

    render () {
        let { level, dataList, add_visible, player_loading, playerList, areaList, area_loading } = this.state,
            { getFieldDecorator } = this.props.form,
            columns = [
                {
                    name: "姓名",
                    span: 4,
                    key: "vname",
                },
                {
                    name: "所属队伍",
                    span: 5,
                    key: "teamname",
                },
                {
                    name: "职位",
                    span: 5,
                    key: "teampositionname",
                    default: "暂无",
                },
                {
                    name: "权限",
                    span: 6,
                    key: "object",
                    default: "暂无"
                },
                {
                    name: "操作",
                    span: 4,
                    render: (val, record) => {
                        return (
                            <Popconfirm title="确认删除吗？" onConfirm={() => this.handleDetele(record.id)} okText="是"
                                        cancelText="否">
                                <a href="#" className="link">删除</a>
                            </Popconfirm>
                        )
                    }
                }
            ],
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 14 },
            },
            card_props = {
                title: '全国',
                titleLink: '添加全国白名单'
            },
            rights = app.getData('rights')
        if (level === '2') {
            card_props = {
                title: '省级',
                titleLink: '添加省级白名单'
            }
        } else if (level === '3') {
            card_props = {
                title: '队伍',
                titleLink: '添加队伍白名单'
            }
        }
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Radio.Group defaultValue="3" onChange={this.handleBtnChange}>
                        <Radio.Button value="3">队伍</Radio.Button>

                        {
                            '1'.indexOf(rights) > -1 ? (
                                <Radio.Button value="2">省级</Radio.Button>
                            ) : null
                        }
                        {
                            rights === 1 ? (
                                <Radio.Button value="1">全国</Radio.Button>
                            ) : null
                        }
                    </Radio.Group>
                </div>
                <div className="cards" style={{ height: "calc(100% - 32px)" }}>
                    <Card2 style={{ width: '80%' }} {...card_props}
                           data={dataList} columns={columns}
                           titleLinkClick={() => this.handleOpenAddModal()}/>
                    <p style={{color: 'red'}}>注: 添加到【报表管理白名单】里的队员，即拥有管理工作报表数据的权限</p>
                </div>
                <Modal
                    visible={add_visible}
                    onCancel={this.handleCloseAddModal}
                    footer={null}
                    title={<div style={{ textAlign: "center" }}>添加白名单</div>}
                    maskClosable={false}
                    destroyOnClose={true}
                    keyboard={false}
                    width="40%"
                    zIndex={1002}
                    centered={true}
                >
                    <Form onSubmit={this.handleAdd}>
                        <FormItem
                            label="添加人员"
                            {...formItemLayout}
                        >
                            <span>
                                <Select defaultValue="searchform_name" style={{ width: '30%' }}
                                        onChange={(value) => this.setData({ player_search_type: value })}>
                                    <Option value="searchform_name">名称</Option>
                                    <Option value="searchform_code">编号</Option>
                                </Select>
                            </span>
                            {getFieldDecorator('object_volunteer', {
                                rules: [{
                                    required: true,
                                    message: "请选择人员"
                                }]
                            })(
                                <Select placeholder="请输入关键词搜索" onSearch={this.handleSearchPlayer}
                                        style={{ width: '60%' }}
                                        notFoundContent={player_loading ? <Spin size="small"/> : "无搜索内容"}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        allowClear
                                        showSearch>
                                    {
                                        (playerList || []).map((p) => {
                                            return (
                                                <Option key={p.indexno}>{`${p.vname}（${p.bsrno || '-'}）`}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>
                        {
                            level !== '1' ? (
                                <FormItem
                                    label="添加权限"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('object', {
                                        rules: [{
                                            required: true,
                                            type: 'array',
                                            message: "请选择权限"
                                        }]
                                    })(
                                        <Select placeholder="请选择" onSearch={this.handleSearchPlayer}
                                                style={{ width: '90%' }}
                                                mode="multiple"
                                                notFoundContent={area_loading ? <Spin size="small"/> : "无搜索内容"}
                                                optionFilterProp="children"
                                                showSearch
                                                allowClear>
                                            {
                                                (areaList || []).map((p) => {
                                                    return (
                                                        <Option key={p.value}>{p.name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                            ) : null
                        }
                        <FormItem wrapperCol={{ offset: 6 }}>
                            <Button type="primary" htmlType="submit">添加</Button>
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(WhiteList)



// WEBPACK FOOTER //
// ./src/routes/sign/WhiteList.jsx